module.exports = __webpack_public_path__ + "static/media/gummy-green.43645d4c.png";